exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".full-width {\n  width: 85%;\n\n}\n\n.customer-fields {\n  margin: 5px;\n  padding: 5px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/intake-form/intake-form.style.css
// module id = 1126
// module chunks = 0